module.exports = __webpack_public_path__ + "static/gallery5-7de249d3422aee1cc1c0b86a199b10d0.jpg";